export enum PaymentType {
  DUE_ON_RECEIPT = 'Due on receipt',
  PREPAID_CREDIT = 'Prepaid credit',
  CREDIT_CARD_ON_FILE = 'Credit card on file',
  PREPAID = 'Prepaid',
  JOB_SITE = 'Job site',
  NET_TERM = 'Net Term',
}
